// extracted by mini-css-extract-plugin
export default {"main":"TrainingView_main__OhklM","solve":"TrainingView_solve__pBcQv","knownBar":"TrainingView_knownBar__W-72L","viewCount":"TrainingView_viewCount__EA5rj"};